<template>
  <app-content class="h-panel" style="overflow: hidden">
    <div style="margin: 20px 20px 0px 20px">
      <DropdownCustom ref="paramsDropdown" button class="h-btn-primary" trigger="click">
<!--        <div v-if="params.voucherDate.start!==params.voucherDate.end">{{ fqFormat(params.voucherDate.start) }} 至 {{ fqFormat(params.voucherDate.end) }}</div>-->
<!--        <div v-else>{{ fqFormat(params.voucherDate.start) }}</div>-->
        <div>{{ params.voucherDate.start }} 至 {{ params.voucherDate.end }}</div>
        <template #content>
          <Form style="padding: 10px;width: 400px">
<!--            <FormItem class="!pb-5px" label="会计期间">-->
<!--              <div class="flex items-center">-->
<!--                <Select v-model="params.voucherDate.start" :deletable="false" filterable :datas="checkoutSelect"/>-->
<!--                <span class="mx-8px">至</span>-->
<!--                <Select v-model="params.voucherDate.end" :deletable="false" filterable :datas="checkoutSelect"/>-->
<!--              </div>-->
<!--            </FormItem>-->
            <FormItem class="!pb-5px" label="日期">
              <div class="flex items-center">
                <DatePicker v-model="params.voucherDate.start" :clearable="false" :option="{end:params.voucherDate.end}"/>
                <span class="mx-8px">至</span>
                <DatePicker v-model="params.voucherDate.end" :clearable="false" :option="{start:params.voucherDate.start}"/>
              </div>
            </FormItem>
            <FormItem class="!pb-5px"  label="凭证字">
              <Select :datas="voucherWordList" keyName="word" titleName="word" v-model="params.word"/>
            </FormItem>
            <FormItem class="!pb-5px"  label="凭证号">
              <div class="h-input-group">
                <NumberInput v-model.number="params.codeStart"/>
                <span class="h-input-addon">至</span>
                <NumberInput v-model.number="params.codeEnd"/>
              </div>
            </FormItem>
            <FormItem class="!pb-5px"  label="制单人">
              <Select :datas="userList" v-model="params.createMember" keyName="id" titleName="realName"/>
            </FormItem>
            <FormItem class="!pb-5px" label="摘要">
              <Input v-model="params.summary"/>
            </FormItem>
            <FormItem class="!pb-5px"  label="科目">
              <Select :datas="subjectList" keyName="id" titleName="name" v-model="params.subjectId" :filter="subjectFilter">
                <template v-slot:item="{ item }">
                  {{ item.code }} {{ item.name }}
                </template>
              </Select>
            </FormItem>
            <FormItem class="!pb-5px" label="备注">
              <Input v-model="params.remark"/>
            </FormItem>
            <FormItem class="!pb-10px" label="借方金额">
              <div class="flex items-center">
                <NumberInput v-model="params.minDebitAmount"/>
                <span class="mx-8px">至</span>
                <NumberInput v-model="params.maxDebitAmount"/>
              </div>
            </FormItem>
            <FormItem class="!pb-10px" label="贷方金额">
              <div class="flex items-center">
                <NumberInput v-model="params.minCreditAmount"/>
                <span class="mx-8px">至</span>
                <NumberInput v-model="params.maxCreditAmount"/>
              </div>
            </FormItem>

            <FormItem class="!pb-5px" label="审核状态">
              <Radio v-model="params.audit" :datas="[{key:0,title:'全部'},{key:1,title:'已审核'},{key:2,title:'未审核'}]" @change="auditStatusCheck"></Radio>
            </FormItem>
            <FormItem v-if="params.audit==1" class="!pb-5px"  label="审核人">
              <Select :datas="userList" v-model="params.auditMemberId" keyName="id" titleName="realName"/>
            </FormItem>

            <FormItem class="!pb-5px"  label="凭证来源">
              <Select :datas="importParams" v-model="params.isImport" :deletable="true">
              </Select>
            </FormItem>

            <FormItem class="!pb-5px"  label="显示顺序">
              <Select :datas="sortParams" v-model="params.sort" :deletable="false">
              </Select>
            </FormItem>

            <FormItem class="!pb-5px">
              <Button color="primary" @click="reSearch();" :loading="loading">确定</Button>
              <Button @click="this.$refs.paramsDropdown.hide()">取消</Button>
              <Button @click="resetForm">重置</Button>
            </FormItem>
          </Form>
        </template>
      </DropdownCustom>
      <div class="float-right">
        <template v-if="User.role!=='View' && currentAccountSets.voucherReviewed">
          <DropdownMenu button @clickItem="trigger" :datas="{audit:'审核选中',auditAll:'审核全部'}">审核</DropdownMenu>
          <DropdownMenu button @clickItem="trigger" :datas="{cancelAudit:'取消选中',cancelAuditAll:'取消全部'}">取消审核</DropdownMenu>
<!--          <Button :loading="loading" @click="audit">审核</Button>-->
<!--          <Button :loading="loading" @click="cancelAudit">取消审核</Button>-->
        </template>
        <template v-if="User.role!=='View'">
          <DropdownMenu button @clickItem="trigger" :datas="{batchDelete:'删除选中',deleteAll:'删除全部'}">删除</DropdownMenu>
        </template>
        <Button icon="fa fa-refresh" @click="loadList()"/>
        <DropdownMenu button @clickItem="trigger" :datas="param">打印</DropdownMenu>
        <template v-if="User.role!=='View'">
          <Button :loading="loading" @click="finishingOffNo">整理断号</Button>
<!--          <Button :loading="loading" @click="batchDelete">批量删除</Button>-->
          <DropdownMenu button @clickItem="downloadTrigger" :datas="{all:'导出所有',checked:'导出选中'}">导出凭证</DropdownMenu>
          <Button :loading="loading" @click="doUpload">
            导入凭证
          </Button>
        </template>
      </div>
    </div>
    <div class="h-panel-body voucher-list">
      <table class="header" style="overflow-y: scroll;">
        <tr>
          <th style="width: 50px;line-height:7px;"><input :checked="checkAll" type="checkbox" @click="checkAll=!checkAll"></th>
          <td style="width: 215px">摘要</td>
          <td>科目</td>
          <td align="right" style="width: 130px;padding-right:15px;">借方金额</td>
          <td align="right" style="width: 130px;padding-right:15px;">贷方金额</td>
        </tr>
      </table>
      <table v-if="!datas.length">
        <tr>
          <td colspan="5" class="text-center padding">暂无数据</td>
        </tr>
      </table>
      <div style="height: calc(100vh - 314px);overflow-y: auto;">
        <template v-for="data in datas" :key="data.id">
          <router-db-link @success="loadList" width="1050px" :to="{name:'VoucherForm',params:{voucherId:data.id}}">
            <table class="details">
              <tr class="details-header">
                <th style="width: 50px;line-height:7px;"><input :class="{'display':data._checked}" v-model="data._checked" type="checkbox"></th>
                <td colspan="2">日期：<span style="color:#666;">{{ data.voucherDate }}</span> <span style="margin-left:10px;">凭证字号：</span><span style="font-weight:bold;color:#666;">{{ data.word }}-{{ data.code }}</span>
                  <template v-if="data.receiptNum>0 || (data.billList && data.billList.length>0)">
<!--                    <span class="ml-8px text-hover primary-color">-->
<!--                    <i class="fa fa-paperclip"></i> {{ data.receiptNum }}-->
<!--                    </span>-->
                    <a v-if="data.receiptNum>0 || (data.billList && data.billList.length>0)" @click="loadAttachmentList(data.billList);"> <span class="ml-8px text-hover primary-color">
                      <i class="fa fa-paperclip"></i> {{ data.receiptNum }}
                      </span>
                    </a>

<!--                    <DropdownCustom :toggle-icon="false" class-name="h-text-dropdown">-->
<!--                      <span class="ml-8px text-hover primary-color">-->
<!--                      <i class="fa fa-paperclip"></i> {{ data.receiptNum }}-->
<!--                      </span>-->
<!--                      <template #content>-->
<!--                        <div class="w-400px">-->
<!--                          <div class="h-150px">-->
<!--                            <vxe-table ref="billListTable" :data="data.billList" :show-header="false" height="auto">-->
<!--                              <vxe-column field="name">-->
<!--                                <template #default="{row}">-->
<!--                                  <a v-if="row.isExternalLink" :href="row.url" target="_blank">{{ row.name }}</a>-->
<!--                                  <a v-else :href="'/api'+row.url+'?name='+row.name" target="_blank">{{ row.name }}</a>-->
<!--                                </template>-->
<!--                              </vxe-column>-->
<!--                            </vxe-table>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </template>-->
<!--                    </DropdownCustom>-->
                  </template>


                  <span :class="'h-tag' + (data.locked?' h-tag-green':' h-tag-yellow')" style="display:inline;margin-left:10px;border-radius:6px;font-size:12px;">{{ data.locked?'已审核':'未审核' }}</span>
<!--                  <span :class="'h-tag h-tag-primary'" style="display:inline;margin-left:10px;border-radius:6px;font-size:12px;">{{ data.isImport?'系统生成':'手工录入' }}</span>-->
                  <template v-if="data.remark!=undefined && data.remark!=null ">
                    <span style="margin-left:10px;max-width:260px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display:inline-block;line-height: 12px;position:relative;top:2px;">备注：{{ data.remark }}</span>
                  </template>
                </td>
                <td colspan="2">
                  <div class="actions flex justify-end items-center">
                    <a :href="`/api/pdf/voucher?id=${data.id}`" target="_blank" class="fa fa-print">打印</a>
                    <router-link @success="loadList" width="1050px" v-if="User.id==data.createMember && User.role!=='View' && (!currentAccountSets.voucherReviewed || !data.auditMemberId)" class="span fa fa-edit" :to="{name:'VoucherForm',params:{voucherId:data.id}}">修改</router-link>
                    <span v-if="User.id==data.createMember && User.role!=='View' && (!currentAccountSets.voucherReviewed || !data.auditMemberId)" @click="remove(data)" class="fa fa-trash">删除</span>
                    <router-link @success="loadList" width="1050px" v-if="User.role!=='View'" class="span fa fa-copy" :to="{name:'VoucherForm',params:{voucherId:data.id,copy:true}}">复制</router-link>
                    <router-link class="text-hover" width="1050px" v-if="currentAccountSets.voucherReviewed && data.auditMemberId" tag="span" :to="{name:'VoucherForm',params:{voucherId:data.id}}">
                      <i class="h-icon-completed green-color" content="已审核"></i> 查看
                    </router-link>
                  </div>
                </td>
              </tr>
              <template v-for="d in data.details" :key="d.id">
                <tr v-if="(params.summary=='' || ( d.summary.indexOf(params.summary)>-1))
                && (params.subjectId==null || ( d.subjectId == params.subjectId))
                && (params.minCreditAmount==null || ( d.creditAmount >= params.minCreditAmount))
                && (params.maxCreditAmount==null || ( d.creditAmount <= params.maxCreditAmount))
                && (params.minDebitAmount==null || ( d.debitAmount >= params.minDebitAmount))
                && (params.maxDebitAmount==null || ( d.debitAmount <= params.maxDebitAmount))">
                  <th></th>
                  <td style="width: 215px">
                    {{ d.summary }} <span v-if="d.currencyName && d.currencyId !== localCurrency.id">({{ d.currencyName }}：{{ d.originalAmount }}，汇率：{{ d.exchangeRate }})</span>
                    <template v-if="d.subject&&d.num&&d.price">
                      (数量:{{ d.num }}<span class="dark4-color">{{ d.subject.unit }}</span>，单价:{{ d.price }}<span class="dark4-color">元</span>)
                    </template>
                  </td>
                  <td>{{ d.subjectName }}<span v-if="d.auxiliaryDetailId">_{{ d.auxiliaryTitle }}</span></td>
                  <td align="right" style="width: 130px">{{ numFormat(d.debitAmount) }}</td>
                  <td align="right" style="width: 130px">{{ numFormat(d.creditAmount) }}</td>
                </tr>
              </template>
              <tr class="font-bold" >
                <td></td>
                <td>合计</td>
                <td>{{ dxMoney(data.debitAmount) }}</td>
                <td align="right">{{ numFormat(data.debitAmount) }}</td>
                <td align="right">{{ numFormat(data.creditAmount) }}</td>
              </tr>
            </table>
          </router-db-link>
        </template>

      </div>

<!--      <Pagination v-model="pagination" @change="currentChange" layout="pager" small align="center"/>-->
      <vxe-pager
          :layouts="['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'PageCount','Total']"
          v-model:current-page="pagination.page"
          v-model:page-size="pagination.pageSize"
          :page-sizes="[10,20,50,100,200]"
          :total="pagination.total"
          align="center"
          @page-change="currentChange">
      </vxe-pager>
    </div>
    <Modal v-model="modalOpened">
      <div slot="header">Vue</div>
      <div >这是使用vue调用的弹出框</div>
      <div slot="footer">
        <Button color="primary" @click="modalConfirm">确认</Button>
        <Button @click="modalClose">关闭</Button>
        <Button color="red" @click="modalDelete">删除</Button>
      </div>
    </Modal>
  </app-content>

</template>

<script>
import Qs from "qs";
import {mapActions, mapGetters, mapState} from 'vuex'
import {h, ref} from 'vue'
import {clone, pick} from "xe-utils";
import {layer} from "@layui/layer-vue";
import VoucherImport from "@/views/voucher/VoucherImport";
import manba from "manba";
import voucher from "@/api/voucher";
import {downloadBlob} from "download.js";
import VoucherAttachmentList from "@/views/voucher/VoucherAttachmentList.vue";
import FinishingOffNo from "@/views/voucher/FinishingOffNo.vue";
import {message,modal} from "heyui.ext";
import setting from "@api/setting";

export default {
  name: "Voucher",
  data() {
    return {
      modalOpened:false,
      datas: [],
      subjectList: [],
      userList:[],
      voucherWordList: [],
      accountDate: null,
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      params: {
        voucherDate: {start: null, end: null},
        audit: 0,
        word: null,
        codeStart: null,
        codeEnd: null,
        createMember: null,
        auditMemberId: null,
        summary: "",
        subjectId: null,
        minDebitAmount: null,
        maxDebitAmount: null,
        minCreditAmount: null,
        maxCreditAmount: null,
        sort: 'desc',
        isImport: null,
      },
      loading: false,
      checkAll: false,
      param: [{title: '打印全部', key: 'printAll'}, {title: '打印选中', key: 'printCheck'}],
      sortParams: [{ title: '正序', key: 'asc' }, { title: '倒序', key: 'desc' }],
      importParams: [{ title: '手工录入', key: 0 }, { title: '系统生成', key: 1 }],
    };
  },
  watch: {
    checkAll(nval) {
      let data = Array.from(this.datas);
      data.forEach(val => val._checked = nval);
      this.datas = data;
    }
  },
  computed: {
    ...mapState(['User', 'currentAccountSets']),
    ...mapGetters(['checkoutSelect', 'localCurrency']),
    date() {
      return manba(this.accountDate);
    }
  },
  methods: {
    ...mapActions(['init']),
    currentChange() {
      this.loadList();
    },
    trigger(key) {
      this[key].call(this);
    },
    downloadTrigger(key) {
      if (key === 'all') {
        voucher.download(this.params).then((data) => {
          downloadBlob(this.currentAccountSets.companyName + (manba().format('YYYYMMDDHHmmss')) + "凭证.xlsx", data);
        })
      } else {
        let checked = this.datas.filter(value => value._checked);
        if (checked.length) {
          voucher.download({id: checked.map(value => value.id)}).then((data) => {
            downloadBlob(this.currentAccountSets.companyName + (manba().format('YYYYMMDDHHmmss')) + "凭证.xlsx", data);
          })
        } else {
          this.$Message("未选择记录");
        }
      }
    },
    printAll() {
      let print_params = Object.assign({indices: false,voucherDateStart:this.params.voucherDate.start,voucherDateEnd:this.params.voucherDate.end}, this.params);
      let param = Qs.stringify(print_params);
      window.open(`/api/pdf/voucher?${param}`);
    },
    printCheck() {
      let checked = this.datas.filter(value => value._checked);
      if (checked.length) {
        let param = Qs.stringify({id: checked.map(value => value.id)}, {indices: false});
        window.open(`/api/pdf/voucher?${param}`);
      } else {
        this.$Message("未选择记录");
      }
    },
    auditStatusCheck(data) {
      if(data.key!=1){
        this.params.auditMemberId = null;
      }
    },
    reSearch(){
      this.pagination.page = 1; //初始化页码
      this.loadList();
    },
    loadList() {
      const voucherSort = localStorage.getItem("voucher_sort");
      if(voucherSort == 'asc' || voucherSort == 'desc' ){
        if(voucherSort != this.params.sort){
          localStorage.setItem("voucher_sort", this.params.sort);
        }
      }else{
        localStorage.setItem("voucher_sort", this.params.sort);
      }

      const loadId = layer.load(2);
      voucher.list(this.pagination, this.params).then(({data}) => {
        this.datas = data.results || [];
        this.pagination.total = data.total;
      }).finally(() => {
        layer.close(loadId)
        this.$refs.paramsDropdown.hide()
      })
    },
    getSubjectList() {
      setting.subject.voucherSelect().then(({data}) => {
        this.subjectList = data;
      })
    },
    subjectFilter(item, val) {
      return item.code.indexOf(val) !== -1 || item.name.indexOf(val) !== -1 || item.mnemonicCode.indexOf(val) !== -1;
    },
    getUserList() {
      setting.user.list().then(({data}) => {
        this.userList = data;
      })
    },
    getVoucherWordList() {
      setting.voucherWord.list().then(({data}) => {
        this.voucherWordList = data;
      })
    },
    remove(row) {
      if(row.createMember!=this.User.id){
        this.$Message("只能删除自己制作的凭证~");
        return;
      }
      if(row.auditMemberId!=null && row.auditMemberId!=""){
        this.$Message("不能删除已经审核的凭证~");
        return;
      }
      this.$Confirm("确认删除?").then(() => {
        const loadId = layer.load(2);
        voucher.delete([pick(row, ['id', 'year', 'month'])]).then(({ret}) => {
          console.log(ret);
          //
          // if (ret && ret.length) {
          //   this.$Message("部分删除不成功，请检查所在账期是否已结账~")
          // } else {
          //   this.$Message("已审核 "+ret.data+" 张凭证！");
          //   this.init();
          // }

          this.loadList();
        }).finally(() => layer.close(loadId))
      });
    },
    loadAttachmentList(billList) {
      if(billList.length==0){
        this.$Message("没有可查看的附件");
        return;
      }
      let clientHeight = document.documentElement.clientHeight;
      let screenHeight = screen.height;
      let windowHeight = '680px';
      if(clientHeight>780){
        windowHeight = '90%';
      }else if(clientHeight<680){
        windowHeight = '100%';
      }
      let layerId = layer.open({
        title: "附件列表",
        shadeClose: true,
        closeBtn: 1,
        zIndex: 1000,
        area: ['1100px', windowHeight],
        content: h(VoucherAttachmentList, {
          billList: billList,
          onClose: () => {
            layer.close(layerId);
          },
          onSuccess: () => {
            layer.close(layerId);
            this.loadList();
          },
        })
      });
    },
    finishingOffNo() {
      let layerId = layer.open({
        title: "断号整理",
        shadeClose: false,
        closeBtn: false,
        zIndex: 1000,
        area: ['400px', 'auto'],
        content: h(FinishingOffNo, {
          onClose: () => {
            layer.close(layerId);
          },
          onSuccess: () => {
            layer.close(layerId);
            this.loadList();
          }
        })
      });
    },
    batchDelete() {
      let checked = this.datas.filter(value => value._checked);
      if (checked.length) {
        const userId = this.User.id;
        let otherCreated = checked.filter(value => value.createMember != userId);
        if (otherCreated.length) {
          this.$Message("只能删除自己制作的凭证~");
          return
        }

        let audited = checked.filter(value => value.auditMemberId!=null && value.auditMemberId!="" );
        if (audited.length) {
          this.$Message("不能删除已经审核的凭证~");
          return
        }

        this.$Confirm("确认删除?").then(() => {
          const loadId = layer.load(2);
          this.$api.voucher.delete(checked.map(val => pick(val, ['id', 'year', 'month']))).then((ret) => {
            this.$Message("已刪除 "+ret.data+" 张凭证！");

            this.init();
            this.loadList();
          }).finally(() => {
            layer.close(loadId);
          });
        });
      } else {
        message.warn("请选择凭证~");
      }
    },
    deleteAll() {

        this.$Confirm("确认删除?").then(() => {
          modal({
            title: '操作提示',
            content: "<div style='display: flex'><i class=\"h-icon-warn yellow-color\" style=\"font-size:28px;vertical-align: -8px;margin-right: 8px\"></i><div>正在删除筛选条件的所有凭证，</br>删除后该批凭证无法恢复，是否继续？</div></div>",
            buttons: [
              {
                type: 'cancel',
                name: '取消'
              },
              {
                type: 'delete',
                name: '删除',
                style: 'red'
              }
            ],
            events: {
              delete: modal => {
                modal.close();
                const loadId = layer.load(2);
                voucher.deleteAll(this.params).then((ret) => {
                  this.$Message("已刪除 "+ret.data+" 张凭证！");
                  this.init();
                  this.loadList();

                }).finally(() => {
                  layer.close(loadId);
                });
              },
              cancel: modal => {
                modal.close();

              }
            }
          });


          // this.$Confirm("正在删除"+this.params.voucherDate.start+"至"+this.params.voucherDate.end+"的所有凭证，删除后该批凭证无法恢复，是否继续？").then(() => {
          //   const loadId = layer.load(2);
          //   this.$api.voucher.delete(checked.map(val => pick(val, ['id', 'year', 'month']))).then(({ret}) => {
          //     console.log(ret)
          //
          //     this.init();
          //     this.loadList();
          //   }).finally(() => {
          //     layer.close(loadId);
          //   });
          // });
        });
    },
    audit() {
      let checked = this.datas.filter(value => value._checked);

      if (checked.length) {
        const userId = this.User.id;
        let myCreated = checked.filter(value => value.createMember == userId);
        if (myCreated.length) {
          this.$Message("不能审核自己制作的凭证~");
          return
        }
        const vdates = new Set(checked.map(val => val.year + "" + val.month))

        if (vdates.size > 1) {
          this.$Message("不能跨期操作~");
          return
        }
        this.$Confirm("亲，确认要审核吗?").then(() => {
          this.loading = true;
          this.$api.voucher.audit({
            checked: checked.map(value => value.id),
            year: checked[0].year,
            month: checked[0].month
          }).then((ret) => {
            this.loadList();
            this.$Message("已审核 "+ret.data+" 张凭证~");
          }).finally(() => {
            this.loading = false;
          });
        });
      } else {
        this.$Message("未选择记录");
      }
    },
    auditAll() {
      this.$Confirm("亲，确认要审核全部吗?").then(() => {
        this.loading = true;
        voucher.auditAll(this.params).then((ret) => {
          this.loadList();
          this.$Message("已审核 "+ret.data+" 张凭证！");
        }).finally(() => {
          this.loading = false;
        })
      });

    },
    cancelAudit() {
      let checked = this.datas.filter(value => value._checked);
      if (checked.length) {
        const userId = this.User.id;
        let myCreated = checked.filter(value => value.createMember == userId);

        let audited = checked.filter(value => {
          return value.auditMemberId!=undefined
        });
        if (audited.length==0) {
          this.$Message("您选择的凭证还未审核~");
          return
        }

        let otherAudited = checked.filter(value => {
          return value.auditMemberId!=undefined && value.auditMemberId != userId
        });
        if (otherAudited.length) {
          this.$Message("只能取消自己审核的凭证~");
          return
        }
        if (myCreated.length) {
          this.$Message("不能取消审核自己制作的凭证~");
          return
        }
        const vdates = new Set(checked.map(val => val.year + "" + val.month))
        if (vdates.size > 1) {
          this.$Message("不能跨期操作~");
          return
        }
        this.$Confirm("亲，确认要取消审核吗?").then(() => {
          this.loading = true;
          this.$api.voucher.cancelAudit({
            checked: checked.map(value => value.id),
            year: checked[0].year,
            month: checked[0].month
          }).then((ret) => {
            this.loadList();
            this.$Message("已取消审核 "+ret.data+" 张凭证~");
          }).finally(() => {
            this.loading = false;
          });
        });
      } else {
        this.$Message("未选择记录");
      }
    },
    cancelAuditAll() {
      this.$Confirm("亲，确认要取消全部审核吗?").then(() => {
        this.loading = true;
        voucher.cancelAuditAll(this.params).then((ret) => {
          this.loadList();
      this.$Message("已取消审核 "+ret.data+" 张凭证~");
        }).finally(() => {
          this.loading = false;
        })
      });

    },
    doUpload() {
      let layerId = layer.open({
        title: "批量导入凭证",
        shadeClose: false,
        closeBtn: false,
        zIndex: 1000,
        area: ['500px', 'auto'],
        content: h(VoucherImport, {
          onClose: () => {
            layer.close(layerId);
          },
          onSuccess: () => {
            layer.close(layerId);
            this.loadList()
          }
        })
      });
    },
    resetForm() {
      this.params = clone(this.cloneParams, true)
    }
  },
  created() {

    const currentAccountDate = manba(this.currentAccountSets.currentAccountDate);
    const startDate = ref(currentAccountDate.startOf(manba.MONTH).format());
    const endDate = ref(currentAccountDate.endOf(manba.MONTH).format());
    this.params.voucherDate.start = startDate;
    this.params.voucherDate.end = endDate;

    const voucherSort = localStorage.getItem("voucher_sort");
    if(voucherSort == 'asc' || voucherSort == 'desc' ){
      this.params.sort = voucherSort;
    }
    this.cloneParams = clone(this.params, true);
    this.loadList();
    this.getSubjectList();
    this.getUserList();
    this.getVoucherWordList();
  }
};
</script>
